module.exports = __webpack_public_path__ + "img/home-presentation.52fd317f.png";